import { Component, Input, OnChanges, OnInit, SimpleChanges, ViewChildren } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { ToolDetails } from '@app/tool/model/toolDetails.model';
import { InputDurationComponent } from '@components/form';
import * as moment from 'moment';

@Component({
    selector: 'app-lifecycle-form',
    templateUrl: './lifecycle-form.component.html',
    styleUrls: ['./lifecycle-form.component.scss']
})
export class LifecycleFormComponent implements OnInit, OnChanges {

    @ViewChildren(InputDurationComponent) inputDurationComponents: InputDurationComponent[];

    @Input() showValidations = false;
    @Input() toolDetails: ToolDetails;

    lifecycleForm: UntypedFormGroup;

    constructor() {
    }

    ngOnInit() {
        this.lifecycleForm = new UntypedFormGroup({
            partNumbersCount: new UntypedFormControl(this.toolDetails.partNumbersCount),
            expirationDate: new UntypedFormControl(
            this.toolDetails.expirationDate
                ? moment(this.toolDetails.expirationDate, 'DD-MM-YYYY HH:mm').toDate()
                : null
            ),
            toolRevisionPercent: new UntypedFormControl(this.toolDetails.toolRevisionPercent)
        });
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['toolDetails'] && this.toolDetails && this.lifecycleForm) {
            this.loadFormValues(this.toolDetails);
        }
    }

    isFormValid() {
        return this.lifecycleForm.valid;
    }

    reset() {
        this.lifecycleForm.reset();
        this.inputDurationComponents.forEach((component) => {
            component.resetTimeUnit();
        });
    }

    value() {
        return this.lifecycleForm.value;
    }

    private loadFormValues(toolDetails: ToolDetails) {
        this.lifecycleForm.patchValue({
            partNumbersCount: toolDetails.partNumbersCount,
            expirationDate: toolDetails.expirationDate
                ? moment(toolDetails.expirationDate, 'DD-MM-YYYY HH:mm').toDate()
                : null,
            toolRevisionPercent: toolDetails.toolRevisionPercent
        });
    }
}
